import type { UiStringKey } from '../ui/central-menu-ui.types'

export const CENTRAL_MENU_UI_STRING_KEYS: UiStringKey[] = [
  'btn_store',
  'btn_channel',
  'modules',
  'menu_master',
  'nav1',
  'nav2',
  'nav3',
  'nav4',
  'bc_store',
  'bc_channel',
  'sku_label',
  'scope_store',
  'scope_channel',
  'btn_refresh',
  'btn_retry1',
  'btn_retry2',
  'stat1',
  'stat2',
  'stat3',
  'stat4',
  'stat5',
  'th1',
  'th2',
  'th3',
  'th4',
  'th1c',
  'th2c',
  's_ok',
  's_err1',
  's_err2',
  's_pend1',
  's_pend2',
  's_err3',
  's_pend3',
  's_pend4',
  'i1',
  'i2',
  'i3',
  'i4',
  'i5',
  'i6',
  'i7',
  'i8',
  'i9',
  'i10',
  'c1',
  'c2',
  'c3',
  'c4',
]

export type StoreStatus = 'ok' | 'err1' | 'err2' | 'pending'
export type ChannelStatus = 'ok' | 'err3' | 'pending'
export type StatTone = 'neutral' | 'success' | 'error' | 'pending'

export type StoreSyncStat = {
  value: string
  labelKey: UiStringKey
  tone: StatTone
}

export type ChannelSyncStat = {
  value: string
  labelKey: UiStringKey
  tone: StatTone
}

export type StoreSyncRow = {
  code: string
  nameKey: UiStringKey
  status: StoreStatus
  statusLabelKey: UiStringKey
  time?: string
  timeKey?: UiStringKey
}

export type ChannelSyncRow = {
  code: string
  name?: string
  nameKey?: UiStringKey
  badge: string
  badgeTone: string
  status: ChannelStatus
  statusLabelKey: UiStringKey
  time?: string
  timeKey?: UiStringKey
}

export const STORE_SYNC_STATS: StoreSyncStat[] = [
  { value: '1025', labelKey: 'stat1', tone: 'neutral' },
  { value: '1010', labelKey: 'stat2', tone: 'success' },
  { value: '12', labelKey: 'stat3', tone: 'error' },
  { value: '3', labelKey: 'stat4', tone: 'pending' },
] as const

export const STORE_SYNC_ROWS: StoreSyncRow[] = [
  { code: 'STR-001', nameKey: 'i1', status: 'ok', statusLabelKey: 's_ok', time: '22/03/2026 14:05:10' },
  { code: 'STR-002', nameKey: 'i2', status: 'ok', statusLabelKey: 's_ok', time: '22/03/2026 14:05:12' },
  { code: 'STR-005', nameKey: 'i3', status: 'err1', statusLabelKey: 's_err1', time: '22/03/2026 14:06:01' },
  { code: 'STR-101', nameKey: 'i4', status: 'ok', statusLabelKey: 's_ok', time: '22/03/2026 14:05:15' },
  { code: 'STR-102', nameKey: 'i5', status: 'err2', statusLabelKey: 's_err2', time: '22/03/2026 14:06:05' },
  { code: 'STR-105', nameKey: 'i6', status: 'pending', statusLabelKey: 's_pend2', timeKey: 's_pend1' },
  { code: 'STR-108', nameKey: 'i7', status: 'ok', statusLabelKey: 's_ok', time: '22/03/2026 14:05:18' },
  { code: 'STR-112', nameKey: 'i8', status: 'ok', statusLabelKey: 's_ok', time: '22/03/2026 14:05:19' },
  { code: 'STR-201', nameKey: 'i9', status: 'ok', statusLabelKey: 's_ok', time: '22/03/2026 14:05:22' },
  { code: 'STR-305', nameKey: 'i10', status: 'ok', statusLabelKey: 's_ok', time: '22/03/2026 14:05:25' },
] as const

export const CHANNEL_SYNC_STATS: ChannelSyncStat[] = [
  { value: '7', labelKey: 'stat5', tone: 'neutral' },
  { value: '5', labelKey: 'stat2', tone: 'success' },
  { value: '1', labelKey: 'stat3', tone: 'error' },
  { value: '1', labelKey: 'stat4', tone: 'pending' },
] as const

export type MenuItem = {
  value: string
  label: string
  sku: string
  image: string
}

export const MENU_ITEMS: MenuItem[] = [
  { value: 'phin-sua-da', label: 'Phin Sữa Đá', sku: 'HLC-PHIN-01', image: '/images/photo-phin-sua-da.webp' },
  { value: 'tra-sen-vang', label: 'Trà Sen Vàng', sku: 'HLC-TSV-02', image: '/images/photo-tra-sen-vang.webp' },
  { value: 'phindi-hanh-nhan', label: 'Phindi Hạnh Nhân', sku: 'HLC-PHN-03', image: '/images/photo-phindi-hanh-nhan.webp' },
  { value: 'freeze-tra-xanh', label: 'Freeze Trà Xanh', sku: 'HLC-FTX-04', image: '/images/photo-freeze-tra-xanh.webp' },
] as const

export const CHANNEL_SYNC_ROWS: ChannelSyncRow[] = [
  { code: 'API-GRF-01', name: 'GrabFood', badge: 'Gr', badgeTone: 'grab', status: 'ok', statusLabelKey: 's_ok', time: '22/03/2026 14:05:08' },
  { code: 'API-SPF-01', name: 'ShopeeFood', badge: 'Sh', badgeTone: 'shopee', status: 'ok', statusLabelKey: 's_ok', time: '22/03/2026 14:05:10' },
  {
    code: 'API-BEF-01',
    name: 'BeFood',
    badge: 'be',
    badgeTone: 'be',
    status: 'pending',
    statusLabelKey: 's_pend3',
    timeKey: 's_pend4',
  },
  { code: 'INT-APP-01', nameKey: 'c1', badge: 'HL', badgeTone: 'brand-red', status: 'ok', statusLabelKey: 's_ok', time: '22/03/2026 14:05:01' },
  { code: 'INT-WEB-01', nameKey: 'c2', badge: 'HL', badgeTone: 'brand-red', status: 'ok', statusLabelKey: 's_ok', time: '22/03/2026 14:05:02' },
  { code: 'API-MMO-01', nameKey: 'c3', badge: 'M', badgeTone: 'momo', status: 'err3', statusLabelKey: 's_err3', time: '22/03/2026 14:06:15' },
  { code: 'API-ZLO-01', nameKey: 'c4', badge: 'Z', badgeTone: 'zalo', status: 'ok', statusLabelKey: 's_ok', time: '22/03/2026 14:05:12' },
] as const

